import React from "react";
const CommentSkeleton = ({ count = 9 }) => {
    return (
        <div className="comment-skeleton">
            {Array.from({ length: count }).map((_, i) => (
                <div className="comment-skeleton-item" key={i}>
                    <div className="skeleton-avatar" />

                    <div className="skeleton-content">
                        <div className="skeleton-line short" />
                        <div className="skeleton-line" />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default CommentSkeleton;
